import { CMDSpBetResult } from "./CMDSpBetResult"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpTipsResult implements ICommand
{

	public Tips : CMDSpBetResult;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Tips = new CMDSpBetResult();
		this.Tips.fromBytes(ba);
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		let tempBuf0 = this.Tips.toBytes().toBuffer();
		ba.appendBuf(tempBuf0)

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpTipsResult();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Tips(CMDSpBetResult)='+this.Tips+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50088;
	}

	public getCmdName() : string
	{
		return 'SpTipsResult';
	}

}
